import {
  IPromotionDocumentUploadRepository,
  SubmitPromotionDocumentParams,
  SubmitPromotionDocumentResponse,
} from "@/core/repositories/promotion/IPromotionDocumentUpload.repository";

export class SubmitPromotionDocumentUseCase {
  constructor(private readonly promotionDocumentUploadRepository: IPromotionDocumentUploadRepository) {}

  async execute(params: SubmitPromotionDocumentParams): Promise<SubmitPromotionDocumentResponse> {
    return this.promotionDocumentUploadRepository.submitDocument(params);
  }
}
